export const colorsConfig = {
  under: 'rgb(38, 171, 164)',
  neutral: 'rgb(50, 150, 237)',
  over: 'rgb(157, 83, 242)',
  none: 'rgb(176, 173, 171)',
  excluded: 'rgb(236, 235, 234)'
};

export const chartConfig = {
  transforms: {
    rotate: true
  },
  autoFitMode: 'fit',
  barSpacer: 2,
  lineWidth: 2,
  pointRadius: 8,
  showPoints: false,
  color: {
    column: ['saturationType']
  },
  plots: [
    {
      column: ['subscribers'],
      mark: 'bar',
      axis: 'measureAxis1'
    },
    {
      column: ['openRate'],
      mark: 'line',
      axis: 'measureAxis2',
      color: 'rgb(247, 167, 0)'
    },
    {
      column: ['clickRate'],
      mark: 'line',
      axis: 'measureAxis2',
      color: 'rgb(0, 108, 213)'
    },
    {
      column: ['unsubscribeRate'],
      mark: 'line',
      axis: 'measureAxis2',
      color: 'rgb(227, 94, 110)'
    }
  ],
  dimensionAxis: {
    column: ['numEmail'],
    showAxis: true,
    showTitle: true
  },
  tooltip: {
    column: [
      'numEmail',
      'eventType',
      'subscribers',
      'openRate',
      'clickRate',
      'unsubscribeRate'
    ],
    showPercentage: true
  },
  measureAxis1: {
    showAxis: true,
    showTitle: true,
    showZero: true,
    scale: 'linear',
    title: ''
  },
  measureAxis2: {
    showAxis: true,
    showTitle: true,
    showZero: true,
    scale: 'linear',
    title: ''
  }
};
